import {
  Building2,
  Database,
  Home,
  LayoutDashboard,
  LogOut,
  Menu,
  ShieldCheck,
  Users,
  BriefcaseMedical,
  X,
} from "lucide-react";

import {
  useEffect,
  useState,
} from "react";

import {
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";

import "../../components/layout/AdminLayout.css";

function AdminLayout() {
  const navigate =
    useNavigate();

  const [
    sidebarOpen,
    setSidebarOpen,
  ] = useState(false);

  const [
    user,
    setUser,
  ] = useState(null);

  useEffect(() => {
    try {
      const storedUser =
        localStorage.getItem(
          "zethUser"
        );

      const token =
        localStorage.getItem(
          "zethAuthToken"
        );

      if (
        !storedUser ||
        !token
      ) {
        navigate(
          "/admin/login",
          {
            replace: true,
          }
        );

        return;
      }

      const parsedUser =
        JSON.parse(
          storedUser
        );

      if (
        parsedUser?.role !==
        "admin"
      ) {
        navigate(
          "/admin/login",
          {
            replace: true,
          }
        );

        return;
      }

      setUser(
        parsedUser
      );
    } catch (error) {
      console.error(
        "Admin layout auth error:",
        error
      );

      navigate(
        "/admin/login",
        {
          replace: true,
        }
      );
    }
  }, [
    navigate,
  ]);

  const handleLogout = () => {
    localStorage.removeItem(
      "zethAuthToken"
    );

    localStorage.removeItem(
      "zethUser"
    );

    sessionStorage.removeItem(
      "zethAuthToken"
    );

    sessionStorage.removeItem(
      "zethUser"
    );

    navigate(
      "/admin/login",
      {
        replace: true,
      }
    );
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const navItems = [
    {
      label: "Dashboard",
      to: "/admin/dashboard",
      icon: LayoutDashboard,
    },

    {
      label: "Facilities",
      to: "/admin/facilities",
      icon: Building2,
    },

    {
      label: "Master Data",
      to: "/admin/master-data",
      icon: Database,
    },

    {
      label: "Professionals",
      to: "/admin/professionals",
      icon: Users,
      disabled: true,
    },

    {
      label: "Assignments",
      to: "/admin/assignments",
      icon: BriefcaseMedical,
      disabled: true,
    },

    {
      label: "Compliance",
      to: "/admin/compliance",
      icon: ShieldCheck,
      disabled: true,
    },
  ];

  return (
    <div className="admin-layout">
      <aside
        className={`admin-sidebar ${
          sidebarOpen
            ? "open"
            : ""
        }`}
      >
        <div className="admin-sidebar-header">
          <button
            type="button"
            className="admin-brand"
            onClick={() =>
              navigate(
                "/admin/dashboard"
              )
            }
          >
            <span className="admin-brand-icon">
              <ShieldCheck
                size={24}
              />
            </span>

            <span>
              <strong>
                Zeth Health
              </strong>

              <small>
                Administration
              </small>
            </span>
          </button>

          <button
            type="button"
            className="admin-sidebar-close"
            onClick={
              closeSidebar
            }
            aria-label="Close navigation"
          >
            <X size={22} />
          </button>
        </div>

        <nav className="admin-sidebar-nav">
          {navItems.map(
            ({
              label,
              to,
              icon: Icon,
              disabled,
            }) => {
              if (disabled) {
                return (
                  <div
                    key={label}
                    className="admin-nav-link disabled"
                  >
                    <Icon
                      size={19}
                    />

                    <span>
                      {label}
                    </span>

                    <small>
                      Soon
                    </small>
                  </div>
                );
              }

              return (
                <NavLink
                  key={label}
                  to={to}
                  onClick={
                    closeSidebar
                  }
                  className={({
                    isActive,
                  }) =>
                    `admin-nav-link ${
                      isActive
                        ? "active"
                        : ""
                    }`
                  }
                >
                  <Icon
                    size={19}
                  />

                  <span>
                    {label}
                  </span>
                </NavLink>
              );
            }
          )}
        </nav>

        <div className="admin-sidebar-bottom">
          <button
            type="button"
            className="admin-nav-home"
            onClick={() =>
              navigate("/")
            }
          >
            <Home
              size={18}
            />

            Home
          </button>

          <div className="admin-sidebar-user">
            <div className="admin-user-avatar">
              {(
                user?.firstName?.[0] ||
                "A"
              ).toUpperCase()}
              {(
                user?.lastName?.[0] ||
                ""
              ).toUpperCase()}
            </div>

            <div>
              <strong>
                {user?.firstName ||
                  "Admin"}{" "}
                {user?.lastName ||
                  ""}
              </strong>

              <span>
                {user?.email ||
                  "admin@zethhealth.ca"}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="admin-sidebar-logout"
            onClick={
              handleLogout
            }
          >
            <LogOut
              size={18}
            />

            Sign Out
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <button
          type="button"
          className="admin-sidebar-overlay"
          onClick={
            closeSidebar
          }
          aria-label="Close navigation"
        />
      )}

      <div className="admin-layout-main">
        <header className="admin-mobile-header">
          <button
            type="button"
            className="admin-mobile-menu"
            onClick={() =>
              setSidebarOpen(
                true
              )
            }
            aria-label="Open navigation"
          >
            <Menu
              size={23}
            />
          </button>

          <strong>
            Zeth Health Admin
          </strong>
        </header>

        <div className="admin-layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;